import { render, staticRenderFns } from "./ResetPasswordSuccess.vue?vue&type=template&id=22915932&scoped=true"
import script from "./ResetPasswordSuccess.vue?vue&type=script&lang=js"
export * from "./ResetPasswordSuccess.vue?vue&type=script&lang=js"
import style0 from "./ResetPasswordSuccess.vue?vue&type=style&index=0&id=22915932&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22915932",
  null
  
)

export default component.exports